export type RadarBackgroundProps = {
  enableRadarRotation: boolean;
  radarSpeedClockwise: string;
  radarSpeedCounterClockwise: string;
  packetDashLength: number;
  packetDashGap: number;
  packetFlowDuration: string;
};

export function RadarBackground({
  enableRadarRotation,
  radarSpeedClockwise,
  radarSpeedCounterClockwise,
  packetDashLength,
  packetDashGap,
  packetFlowDuration,
}: RadarBackgroundProps) {
  return (
    <>
      <defs>
        <filter id="glow" x="-30%" y="-30%" width="160%" height="160%">
          <feGaussianBlur stdDeviation="1.5" result="blur" />
          <feComposite in="SourceGraphic" in2="blur" operator="over" />
        </filter>
      </defs>

      <style>{`
        @keyframes ga-radar-cw {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        @keyframes ga-radar-ccw {
          from { transform: rotate(360deg); }
          to { transform: rotate(0deg); }
        }
        @keyframes ga-packet-flow {
          0% { stroke-dashoffset: ${packetDashGap + packetDashLength}; }
          100% { stroke-dashoffset: 0; }
        }
        @keyframes ga-node-pulse {
          0% { transform: scale(1); opacity: 0.15; }
          50% { transform: scale(1.55); opacity: 0.45; }
          100% { transform: scale(1); opacity: 0.15; }
        }
        @keyframes ga-center-ripple {
          0% { transform: scale(0.95); opacity: 0.1; }
          50% { transform: scale(1.15); opacity: 0.3; }
          100% { transform: scale(0.95); opacity: 0.1; }
        }
        .ga-radar-inner {
          transform-origin: 100px 100px;
          animation: ga-radar-cw ${radarSpeedClockwise} linear infinite;
        }
        .ga-radar-outer {
          transform-origin: 100px 100px;
          animation: ga-radar-ccw ${radarSpeedCounterClockwise} linear infinite;
        }
        .ga-packet {
          stroke-dasharray: ${packetDashLength} ${packetDashGap};
          animation: ga-packet-flow ${packetFlowDuration} linear infinite;
        }
      `}</style>

      {/* 1. Radial Grid Ring System */}
      <g opacity="0.45" className="grid-circles hidden md:block">
        <circle
          cx="100"
          cy="100"
          r="40"
          stroke="var(--ga-line)"
          strokeWidth="0.8"
          strokeDasharray="1.2 2.4"
          className={enableRadarRotation ? "ga-radar-inner" : ""}
        />
        <circle
          cx="100"
          cy="100"
          r="78"
          stroke="var(--ga-line)"
          strokeWidth="0.8"
          strokeDasharray="1.2 2.4"
          className={enableRadarRotation ? "ga-radar-outer" : ""}
        />
      </g>
    </>
  );
}
